import { AxiosInstance, AxiosStatic } from 'axios'
import { ApiRoutesNames } from 'bets.oddprovider.lib.common.ts/api/routes'
import { IBet, IBetStatus } from 'bets.oddprovider.lib.common.ts/models'
import { BaseApiClient } from 'fwork-jsts-common/src/apiClient'
import { FilterQuery } from 'mongoose'
import { store } from '../redux/store'

export class BetsStatusApiClient extends BaseApiClient<IBetStatus, any, FilterQuery<IBetStatus>, IBetStatus, IBetStatus> {
  constructor(axios: AxiosStatic | AxiosInstance) {
    const dotEnvProductionState = store.getState().dotEnvProductionState
    const baseUrl = `${dotEnvProductionState.payload?.APIURL}${ApiRoutesNames.betsStatus}`
    super({
      apiUrl: baseUrl,
      axios,
    })
  }
}